var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(3398 3248)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 32,
    height: 32,
    transform: "translate(-3398 -3248)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M15.235,5.529h4.412V7.294H17.882V18.765a.882.882,0,0,1-.882.882H4.647a.882.882,0,0,1-.882-.882V7.294H2V5.529H6.412V2.882A.882.882,0,0,1,7.294,2h7.059a.882.882,0,0,1,.882.882ZM8.176,9.941v5.294H9.941V9.941Zm3.529,0v5.294h1.765V9.941ZM8.176,3.765V5.529h5.294V3.765Z",
    transform: "translate(-3392.823 -3242.823)",
    fill: "#787c7c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.735cb0f7a9ea633d01add623a8341ba2.svg";
export { ForwardRef as ReactComponent };